<h1 mat-dialog-title>Tier bearbeiten</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-bearbeiten [dialog]="true" [tier]="tier" (saved)="dialogRef.close(tier)">
        <ng-container additional-actions>
            <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
        </ng-container>
    </kiene-gruppe-tier-bearbeiten>
</div>
